<template>
<v-container>

    <div>
        <v-breadcrumbs :items="breadcrumbs" v-if="$local_storage.get('tipo_usuario') == 'Super Usuario' || $local_storage.get('id_cliente') > 0">
            <v-icon slot="divider">forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-row>

        <v-col cols="12">
            <base-material-card color="primary" icon="library_books" title="Publicaciones DOF" class="px-5 py-3">
                <v-card-text class="pa-0">
                    <v-form ref="formreporte" lazy-validation>
                        <v-container grid-list-md text-xs-center>

                            <v-row row wrap>
                                <v-col sm="12" md="4" lg="4">
                                    <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                        <template v-slot:activator="{ on }">
                                            <v-text-field v-on="on" v-model="fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="
                                                                    fecha_de = parseDate(fecha_de)
                                                                    " v-mask="'####-##-##'" :rules="[
                                                                    rules.required,
                                                                    ]">
                                            </v-text-field>
                                        </template>

                                        <v-date-picker v-model="fecha_de" color="secondary" landscape scrollable locale="es-mx" @input="menu1 = false">
                                            <v-spacer />

                                            <v-btn color="secondary" large @click="menu1 = false">
                                                Cancelar
                                            </v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col sm="12" md="4" lg="4">
                                    <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                        <template v-slot:activator="{ on }">
                                            <v-text-field v-on="on" v-model="fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="fecha_a = parseDate(fecha_a)" v-mask="'####-##-##'" :rules="[
                                                        rules.required,
                                                        ]"></v-text-field>
                                        </template>
                                        <v-date-picker v-model="fecha_a" color="secondary" landscape scrollable locale="es-mx" @input="menu2 = false">
                                            <v-spacer />

                                            <v-btn color="secondary" large @click="menu2 = false">
                                                Cancelar
                                            </v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col sm="12" md="2" lg="2">
                                   
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col sm="12" md="4" lg="4">
                                    <v-autocomplete v-model="secretaria" :items="secretarias" :return-object="false" item-text="id" item-value="id" label="Secretaría">
                                    </v-autocomplete>
                                </v-col>
                                 <v-col sm="12" md="4" lg="4">
                                    <v-text-field   prepend-icon="mdi-filter" name="publicacion" label="Publicación" type="text"  v-model="publicacion"   ></v-text-field>
                                </v-col>
                                <v-col sm="12" md="2" lg="2">
                                    <v-btn rounded color="secondary" @click="consultar()">
                                        <v-icon>search</v-icon>Consultar
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                    <div id="datagrid">

                        <v-client-table ref="vuetable" id="lista_pub" :data="publicaciones" :columns="columns" :options="options" class="elevation-2 pa-2">
                            <template slot="noResults">
                                <v-alert :value="true" icon="info" color="info">No se encontro ningun registro</v-alert>
                            </template>
                            <template slot="Fecha" slot-scope="props">
                                {{props.row.Fecha!=undefined?arreglaMes(props.row.Fecha.substring(0,props.row.Fecha.length -8)):''}}
                            </template>

                            <template slot="actions" slot-scope="props">
                                <v-btn target='_blank' v-if="props.row.Publicacion != 'Sin publicación en el DOF el dia hoy, relacionada con la TIGIE.'" fab x-small color="primary" :href="'https://hts.gsmartcode.com/docs/bitacora/' + props.row.SYSID + '.pdf'">
                                    <v-icon>mdi-file</v-icon>
                                </v-btn>
                            </template>
                        </v-client-table>

                    </div>

                </v-card-text>

                <!--     <v-card-actions>
            <v-btn
              color="success"
              min-width="100"
              class="pl-0"
            >
              Sign In
            </v-btn>
          </v-card-actions> -->
            </base-material-card>
        </v-col>

    </v-row>

</v-container>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
    created: function () {

        var f_de = new Date();

        f_de.setDate(f_de.getDate());

        let y_de = f_de.getFullYear();
        let m_de = f_de.getMonth() + 1;
        let d_de = f_de.getDate();

        if (m_de < 10)
            m_de = '0' + m_de;
        if (d_de < 10)
            d_de = '0' + d_de;

        this.fecha_de = y_de + "-" + m_de + "-" + d_de;
        this.fecha_a = y_de + "-" + m_de + "-" + d_de;
        this.consultar();
    },
    mounted: function () {

    },

    methods: {
        arreglaMes(mes) {
            let r = "";
            r = mes.replace('Jan', 'Ene');
            r = r.replace('Apr', 'Abr');
            r = r.replace('Aug', 'Ago');
            r = r.replace('Dec', 'Dic');

            return r;
        },
        parseDate(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
        consultar: function () {
            let self = this;
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let fd = self.fecha_de.replaceAll("-", "");
            let fa = self.fecha_a.replaceAll("-", "");
            let FILTER1 = "";
            let FILTER2 = "";
            if(self.secretaria.length> 0){
              FILTER1 = "%20and%20Secretaria%20like%20'%25" + self.secretaria +"%25'";
            }
             if(self.publicacion.length> 0){
              FILTER2 = "%20and%20Publicacion%20like%20'%25" + self.publicacion +"%25'";;
            }
            self.publicaciones = [];
            fetch("https://hts.gsmartcode.com/api/service?cmd=getTable&tableName=bitacora&filterBy=Fecha%20BETWEEN%20'" + fd + "'%20and%20'" + fa + "'" + FILTER1 + FILTER2 + "&orderBy=&startIndex=1&endIndex=100&formatResult=&apiKey=40A563F8D7864948A4EC6FDB3735F963&maxSizeperValue=")
                .then(response => response.json())
                .then(data => {
                  //  console.log(data);

                    self.publicaciones = data;

                    self.$root.$dialogLoader.hide();

                }).catch(function (error) {
                    console.log(error);
                    self.$root.$dialogLoader.hide();
                });
        },

        regresar() {
            if (this.$local_storage.get("id_cliente") > 0) {
                this.$router.push("/home").catch(() => {});
            } else {
                if (this.$local_storage.get("tipo_usuario") == "Super Usuario") {
                    this.$router.push("/admin").catch(() => {});
                } else {
                    this.$router.push("/").catch(() => {});
                }
            }
        },

    },

    data() {
        return {
            secretarias:[
                    { "id": "SHCP"},
                    { "id": "Economía"},
                    { "id": "Salud"},
                    { "id": "Relaciones Exteriores"},
                    { "id": "Semarnat"},
                    { "id": "Energía"},
                    { "id": "Seguridad Pública"},
                    { "id": "Banco de México"},
                    { "id": "Sagarpa"},
                    { "id": "Sedena"},
                    { "id": "SCT"},
                    { "id": "Instituto Mexicano de la propiedad Industrial"},
                    { "id": "Gobernación"},
                    { "id": "INEGI"},
                    { "id": "Comisión Reguladora de Energía"},
                    { "id": "SAT"},
                    { "id": "Comisión Nacional de Hidrocarburos"},
                    { "id": "Consejo de Salubridad General"}
            ],
            model_filters: '',
            menu1: false,
            menu2: false,
            name: "datagrid",
            columns: ["Fecha", "Secretaria", "Publicacion", "actions"],
            options: {
                filterable: false,
                sortable: ["Fecha", "Secretaria", "Publicacion", ],
                headings: {
                    Fecha: "Fecha",
                    Secretaria: "Secretaría",
                    Publicacion: "Publicación",
                    actions: ""
                },

            },

            rules: {
                required: v => !!v || "Este campo es requerido",
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return pattern.test(value) || "Correo electrónico no valido";
                },
            },
            breadcrumbs: [{
                    text: "Inicio",
                    disabled: false,
                    to: "/admin"
                },
                {
                    text: "Publicaciones DOF",
                    disabled: true,
                    href: ""
                }
            ],
            fecha_de: "",
            fecha_a: "",
            secretaria: "",
            publicacion: "",
            show_loading: true,
            publicaciones: [],

        };
    }
};
</script>

<style scoped>
.VueTables>>>thead th {
    white-space: normal !important;
}

.VueTables>>>tbody td {
    white-space: normal !important;
}
</style>
